import { notificationsData } from "assets/dummyData/notifications";
import React from "react";
import NotificationItem from "../AdminDashboardPage/components/AdminDashboardRecentActivity/NotificationItem";

export default function AdminNotificationsList() {
  const containerStyles = "mb-[30px] bg-white rounded-xl shadow-md blur-2 text-opacity-15 spread-0";

  return (
    <div className={containerStyles}>
      <section className="p-6">
        <h2 className="font-bold text-xl mb-4">Notifications</h2>
        {notificationsData.map((notification) => (
          <NotificationItem key={notification.notificaitonId} notification={notification} />
        ))}
       </section>
    </div>
  );
}
